var _defs, _circle, _line, _line2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack176({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.32,
    cy: 10.18,
    r: 4.32
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.49,
    y1: 1.5,
    x2: 3.49,
    y2: 13.97
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.15,
    y1: 1.5,
    x2: 7.15,
    y2: 13.97
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.53,5.87,8.77,3h.39L9.6,4.88c.05.2.09.39.12.59.07-.31.12-.49.13-.53L10.39,3h.46l.41,1.45a7.23,7.23,0,0,1,.22,1q.06-.27.15-.63L12.08,3h.38l-.79,2.87h-.36L10.7,3.68l-.09-.33-.08.33L9.92,5.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.81,5.87V3h1.08a2.51,2.51,0,0,1,.44,0,.91.91,0,0,1,.35.13.81.81,0,0,1,.23.28.86.86,0,0,1,.09.39.88.88,0,0,1-.24.62,1.1,1.1,0,0,1-.84.25h-.73V5.87Zm.38-1.51h.74a.79.79,0,0,0,.52-.13.5.5,0,0,0,.15-.39.49.49,0,0,0-.09-.3.37.37,0,0,0-.24-.17,1.33,1.33,0,0,0-.35,0h-.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack176);
export default __webpack_public_path__ + "static/media/Symbolpack_1_76.266ce765fba285bf95e6722a6d9305fe.svg";
export { ForwardRef as ReactComponent };